import styled from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  text-align: center;
  padding: 30px 25px 60px;
  background: white;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 45px 80px 60px;
  }
`;

const ContentHeader = styled.h3`
  ${(props) => props.theme.font.heading.v600};
  font-weight: ${(props) => props.theme.font.weight.v400};
  text-transform: uppercase;
  margin: 10px 0;
`;

const ContentBody = styled.div`
  ${(props) => props.theme.font.body.v300};
  font-weight: ${(props) => props.theme.font.weight.v100};
  color: ${(props) => props.theme.color.neutral.v500};
`;

export { ContentWrapper, ContentHeader, ContentBody };
